var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('committee-profile-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"committeeDetails":_vm.committeeDetails,"isLoading":_vm.isLoading}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23fe8f2b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Committees/Profile/CommitteeProfileAllDetails.vue
// module id = 892
// module chunks = 30